import React from 'react';
import { useLocation } from 'react-router-dom';

const CanonicalUrl: React.FC = () => {
  const location = useLocation();
  const baseUrl = 'https://regalgain.com';
  const canonicalUrl = `${baseUrl}${location.pathname}`;

  React.useEffect(() => {
    // Remove any existing canonical tags
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }

    // Add the new canonical tag
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = canonicalUrl;
    document.head.appendChild(link);

    // Cleanup on unmount
    return () => {
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        canonical.remove();
      }
    };
  }, [canonicalUrl]);

  return null;
};

export default CanonicalUrl;